(function () {
  'use strict';

  /* @ngdoc object
   * @name Configuration
   * @requires $stateProvider
   *
   * @description
   *
   */
  angular
    .module('Configuration', [
    ]);

  angular
    .module('Configuration')
    .config(config);

  function config() {
  }

})();
